<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="download" />

    <div id="content" class="main-wrapper" style="height: auto !important;">
<article>
<hh1>Download GB WhatsApp APK </hh1>
<div class="area" style="padding: 20px;border :2px solid #59b66d;border-radius: 20px;">
  <p>Download the newest <a href="/"><strong>GB WhatsApp APK 2026</strong></a> safely from our verified platform. Every file is fully tested, malware-free, and optimized to give you the most reliable experience. Enjoy advanced privacy controls, anti-ban protection, powerful customization, and seamless messaging — all designed for Android users who want more flexibility.</p>
<ul>
<li><strong>App Name:</strong> GB WhatsApp</li>
<li><strong>Version:</strong> v18.80</li>
<li><strong>File Size:</strong> 59 MB</li>
<li><strong>Last Updated:</strong> Just Now</li>
<li><strong>Android Requirement:</strong> 5.0 and above</li>
<li><strong>Developer:</strong> Independent Mod Developer</li>
</ul>
</div>
      <DownloadBtn value="Download Now" mg="1" @download="download" />

<hh2>Installation Guide</hh2>
<p>If installation is blocked, go to: <strong>Settings &gt; Security &gt; Unknown Sources</strong> → Enable it → Reinstall the APK.</p>
<hh2>Why Choose Our Platform?</hh2>
<ul>
<li>Secure and verified APK downloads</li>
<li>Always updated to the latest version</li>
<li>Anti-ban features for worry-free use</li>
<li>Full theme and interface customization</li>
<li>Clear tutorials and expert support</li>
</ul>
<p>With us, downloading GB WhatsApp is simple, safe, and reliable.</p>
</article>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/download.scss';
import HeadNav from '@/components/HeadNav.vue';
import DownloadBtn from '@/components/DownloadBtn.vue';

export default {
  name: 'Download',
  data() {
    return {
      pageName: 'download',
      showapk: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav, DownloadBtn
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadfrom(reason) {
      // this.download();
      // this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    download() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
    // download() {
    // 	console.log(this.apk);
    // 	this.$global.download(this.apk);
    // },
  },
};
</script>

<style lang="scss" scoped></style>
